<template>
	<v-dialog
			content-class="addClientsWrapper"
			:value="true"
			persistent
			width="960"
			transition="dialog-bottom-transition"
	>
		<div class="addClients">
			<div class="addClients_header">
				<span>{{ currentId ? 'Edit' : 'Create' }} client</span>
				<button type="button" @click="closeDialog">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="addClients_body">
				<div class="fieldBlock groupField">
					<div class="groupField_wrap">
						<field
								margin="0 0 10px 0"
								width="300px"
								label="MC#"
								placeholder="Enter mc"
								:set-input-value="mc"
								@updateInput="onInput($event, 'mc')"
						></field>
						<field
								margin="0 0 10px 10px"
								width="300px"
								label="Trucks quantity"
								placeholder="Enter trucks quantity"
								type="number"
								:setInputValue="truck_quantity"
								@updateInput="onInput($event, 'truck_quantity')"
						></field>
						<field
								margin="0 0 10px 10px"
								width="300px"
								label="Сarrier name"
								placeholder="Enter сarrier name"
								:set-input-value="carrier"
								@updateInput="onInput($event, 'carrier')"
						></field>
					</div>
					<div class="groupField_wrap">
						<field
								margin="0 0 10px 0"
								width="300px"
								label="Contact name"
								placeholder="Enter contact name"
								:set-input-value="contact"
								@updateInput="onInput($event, 'contact')"
						></field>
						<field
								:class-error="$v.phone && $v.phone.$error"
								margin="0 0 10px 10px"
								width="300px"
								label="Phone"
								type="phone"
								placeholder="Enter phone"
								:setInputValue="phone"
								@updateInput="onInput($event, 'phone')"
								is-required
								is-phone
						></field>
						<field
								margin="0 0 10px 10px"
								width="300px"
								label="Email"
								placeholder="Enter email"
								:setInputValue="email"
								@updateInput="onInput($event, 'email')"
						></field>
					</div>
					<div class="groupField_wrap">
						<v-radio-group
								v-model="type"
								row
						>
							<v-radio
									v-for="({ text, value, isDisabled }) in radioList"
									:disabled="isDisabled"
									:key="value"
									:label="text"
									:value="value"
							></v-radio>
						</v-radio-group>
					</div>
					<div>
						<comments-table
								:comments="comment"
								:created_by="created_by"
								:name="created_name"
						></comments-table>
					</div>
				</div>
			</div>
			<button-groups
					:preloader="clientsPreloader"
					:is-btn-safe="!type"
					apply-text="submit"
					:created_by="created_by"
					@updateBtnClose="closeDialog"
					@updateSave="onSave"
			></button-groups>
		</div>
		<preload v-if="clientsPreloader"></preload>
	</v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// shared
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
import Preload from "@/shared/Preload/Preload";
import CommentsTable from "@/components/Maintenance/PotentialClient/CommentsTable/CommentsTable";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
	name: "AddClients",
	mixins: [ validationMixin ],
	components: {
		CommentsTable,
		ButtonGroups,
		Preload
	},
	props: {
		currentId: Number,
		typeDefault: Number,
		permissions: Object
	},
	computed: mapGetters([ 'clientsPreloader', 'clients' ]),
	validations: {
		phone: { required },
	},
	data: () => ({
		type: null,
		radioList: [
			{ text: 'Interested', value: 1, isDisabled: false },
			{ text: 'Not interested', value: 2, isDisabled: false },
			{ text: 'Voicemail', value: 5, isDisabled: false },
			{ text: 'Other', value: 3, isDisabled: false },
			{ text: 'On-boarded', value: 4, isDisabled: false }
		],
		mc: '',
		carrier: '',
		contact: '',
		truck_quantity: '',
		phone: '',
		email: '',
		comment: [],
		created_by: null,
		created_name: ''
	}),
	methods: {
		...mapActions([
			'onClientsCreate',
			'onClientsSave',
			'setAlert',
			'onClientsEdit',
			'onClientsDelete',
			'onInvoiceDelete',
			'getClientsDelete',
			'getInvoiceDelete',
			'onClientsPreloader',
		]),
		onCommentList(item) {
			this.comment.push(item);
		},
		onCommentDeleteItem(idx) {
			this.comment.splice(idx, 1);
		},
		onCommentEditItem() {
		
		},
		closeDialog() {
			this.$emit('updateClose');
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					type,
					mc,
					carrier,
					contact,
					truck_quantity,
					phone,
					email,
					comment,
				} = this.$data;
				const values = {
					type,
					mc,
					carrier,
					contact,
					truck_quantity,
					phone,
					email,
					comment,
				};

				await this.onClientsPreloader(true);
				const { status } = await this.onClientsSave({
					values,
					id: this.currentId,
					typeDefault: this.typeDefault
				});

				if (status) {
					this.closeDialog();
					this.$emit('updateFilterList');
					this.setAlert({ type: "success", message: "Saving Successfully" });
					await this.onClientsPreloader(false);
				} else {
					await this.setAlert({ type: "error", message: "Saving error" });
					await this.onClientsPreloader(false);
				}
			} else {
				this.setAlert({ type: "error", message: "You'd enter 'Phone number'" });
			}
		}
	},
	async mounted() {
		if (this.currentId) {
			await this.onClientsEdit(this.currentId);
		} else {
			await this.onClientsCreate(null);
		}

		const { row, comment, created_by, created_name } = this.clients;
		this.created_by = created_by;
		this.created_name = created_name;
		if (row) {
			for (const rowKey in row) {
				if (rowKey !== 'comment') this[rowKey] = row[rowKey];
			}
			
			this.comment = comment;

			this.$set(this.radioList[0], 'isDisabled', this.type !== 1);
		}
	}
};
</script>

<style scoped lang="scss">
@import "addClients";
</style>

<style lang="scss">
@import "../../global";
</style>
